import { conf } from './configService';
import { domainService } from './domainService';
import { urlService } from './urlService';

const normalizeUrl = url => {
  if (
    conf.isPreview &&
    !domainService.isLocalDevDomain(window.location.hostname) &&
    url?.includes('/ajax/') &&
    !urlService.isAbsolute(url)
  ) {
    const previewDataEndpoint = '/preview-data';
    if (url.includes('/ajax/subscription_block')) {
      return url.replace(
        '/ajax/subscription_block',
        `${previewDataEndpoint}/${conf.langcode}/entity/block_content/subscription_block`
      );
    }
    return url.replace(
      '/ajax/',
      `${previewDataEndpoint}/${conf.langcode}/custom/ajax/`
    );
  }
  return url;
};

const normalizedFetch = (url, options) => {
  return fetch(normalizeUrl(url), options).then(response => {
    if (!response.ok) {
      throw new Error(response);
    }
    return response;
  });
};

const handle = (url, options) =>
  normalizedFetch(url, options)
    .then(response => (options.customDecodeJson ? response.json() : response))
    .then(response => ({ response, error: undefined }))
    .catch(error => {
      return { response: undefined, error };
    });

export const apiClientService = {
  // Raw function when you need then() and catch()
  fetch: (url, options) => normalizedFetch(url, options),

  // Sugared functions that never throw and return an object with response and error members.
  get: (url, options) => handle(url, { ...options, method: 'GET' }),
  getJson: (url, options) =>
    handle(url, { ...options, customDecodeJson: true }),
  post: (url, options) => handle(url, { ...options, method: 'POST' }),
  put: (url, options) => handle(url, { ...options, method: 'PUT' }),
  delete: (url, options) => handle(url, { ...options, method: 'DELETE' })
};
